import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialPasswordType: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 10.67H32v10.66h-1.52Zm-1.53 10.66h1.53v1.53h-1.53Zm0-12.19h1.53v1.53h-1.53ZM3.05 22.86h25.9v1.52H3.05Zm18.29-6.1h7.61v1.52h-7.61Zm-3.05 0h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Zm-3.05 3.05h1.53v1.52h-1.53Zm0-3.05h1.53v1.53h-1.53Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.52H9.15Zm0-3.05h1.52v1.53H9.15ZM6.1 16.76h1.52v1.52H6.1Zm0-3.05h1.52v1.53H6.1Zm-1.53 1.53H6.1v1.52H4.57ZM3.05 7.62h25.9v1.52H3.05Zm0 9.14h1.52v1.52H3.05Zm0-3.05h1.52v1.53H3.05Zm-1.52 7.62h1.52v1.53H1.53Zm0-12.19h1.52v1.53H1.53ZM0 10.67h1.53v10.66H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialPasswordType
